export default __webpack_public_path__ + "static/media/total-lectures.4a3211e0.svg";